module.exports = __webpack_public_path__ + "img/loginbg.239bd9e8.png";